import type { CityConfig } from "../city-template/types";

export const rockIslandConfig: CityConfig = {
  city: "Rock Island",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "rock-island",
  route: "/cities/rock-island",
  title: "Emergency Passport Rock Island, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Rock Island, Illinois — as fast as 24 hours. Fast passport renewal for Augustana College students, Arsenal Island personnel, and all Rock Island County residents. A+ BBB rated registered State Dept. courier serving the Quad Cities.",
  h1: "Emergency & Expedited Passport Services in Rock Island, IL",
  heroSubtitle: "Augustana College study abroad to Sweden in 5 days and your passport's expired? Arsenal Island civilian employee with a TDY to Japan? Historic Mississippi River city with international needs but no passport agency nearby. We help Rock Island residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Rock Island County and the Quad Cities.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Rock%20Island%20Illinois%20historic%20downtown%20with%20charming%20brick%20buildings%20and%20the%20Mississippi%20River%20waterfront%2C%20Arsenal%20Island%20and%20the%20Rock%20Island%20Arsenal%20bridge%20in%20the%20distance%2C%20Augustana%20College%20campus%20with%20Old%20Main%20building%20and%20tree%20lined%20walkways%2C%20Quad%20Cities%20skyline%20viewed%20from%20the%20Illinois%20riverbank%2C%20classic%20Midwest%20river%20city%20atmosphere%2C%20scenic%20riverfront%20park%20with%20the%20Centennial%20Bridge%2C%20golden%20hour%20warm%20light%20over%20the%20Mississippi%20River%2C%20professional%20landscape%20photography&width=1800&height=700&seq=rock-island-hero-001&orientation=landscape",
  heroImageAlt: "Rock Island Illinois downtown and Mississippi River waterfront with Arsenal Island at golden hour",
  geoPosition: "41.4910;-90.5788",
  geoPlacename: "Rock Island, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 2 hours 45 minutes east of Rock Island via I-88 / I-290",
  },
  nearbyCitiesZips: [
    { name: "Rock Island", zips: "61201, 61204" },
    { name: "Moline", zips: "61265, 61266" },
    { name: "Milan", zips: "61264" },
    { name: "East Moline", zips: "61244" },
    { name: "Silvis", zips: "61282" },
    { name: "Coal Valley", zips: "61240" },
    { name: "Orion", zips: "61273" },
    { name: "Andalusia", zips: "61232" },
    { name: "Reynolds", zips: "61279" },
    { name: "Taylor Ridge", zips: "61284" },
    { name: "Port Byron", zips: "61275" },
    { name: "Hampton", zips: "61256" },
    { name: "Davenport, IA", zips: "52801, 52802, 52803, 52804, 52806, 52807" },
    { name: "Bettendorf, IA", zips: "52722" },
    { name: "Le Claire, IA", zips: "52753" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — under 3 hours away but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Quad Cities travelers" },
    { icon: "ri-graduation-cap-line", title: "Augustana College Hub", desc: "Serving Augustana College students and faculty with study abroad and international academic travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Rock Island — no 5.5-hour Chicago round trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Davenport, IA", route: "/cities/davenport" },
    { name: "Emergency passport help in Moline, IL", route: "/cities/moline" },
    { name: "Urgent passport services in Peoria, IL", route: "/cities/peoria" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Rock Island, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (2 hours 45 minutes east via I-88 and I-290) — without you making the trip. Rock Island residents can ship from any UPS or FedEx in Rock Island County. For Quad Cities travelers, our courier service saves half a day of driving and downtown Chicago navigation.",
  fpcOfficeDistance: "Serving Rock Island, Moline, Milan, East Moline, Silvis, Coal Valley, Orion, Andalusia, Reynolds, Taylor Ridge, Port Byron, Hampton, Davenport IA, Bettendorf IA, Le Claire IA, and the entire Quad Cities metropolitan area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rock Island and the entire Quad Cities region. From the historic Rock Island downtown and Arsenal Island to the Augustana College campus, from the Mississippi River communities to the residential neighborhoods throughout Rock Island County — we serve the entire Illinois side of the Quad Cities and beyond.",
  nearbyCitiesIntro: "We serve Rock Island and all nearby communities including Moline, Milan, East Moline, Silvis, Coal Valley, Orion, Andalusia, Reynolds, Taylor Ridge, Port Byron, and Hampton. We also serve Davenport, Bettendorf, and Le Claire, Iowa, and the entire Quad Cities region.",
  howItWorksIntro: "Most Rock Island travelers complete everything online and ship documents overnight. No need to drive nearly 3 hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For Quad Cities residents, this saves a full half-day of travel.",
  mistakesIntro: "Rock Island is home to Augustana College with hundreds of students studying abroad each year and Arsenal Island with federal civilian employees traveling internationally — yet the nearest passport agency is nearly 3 hours away. Here are the most common passport mistakes in the Quad Cities.",
  testimonialsIntro: "Rock Island travelers — from Augustana College students heading abroad and Arsenal Island federal employees to Quad Cities families and Mississippi River cruise passengers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Rock Island, IL? Here are the most common ones we hear from Quad Cities travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "5.5+ hour round trip drive to Chicago", "Impractical for most Quad Cities residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 5.5-hour round trip to Chicago required", "Perfect for Augustana study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Rock Island travelers with immediate departure needs — as fast as 24 hours. Essential for Augustana study abroad deadlines and Arsenal Island federal travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 5.5-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Rock Island adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Rock Island address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Rock Island residents — including Augustana College students, new citizens, and Quad Cities families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Rock Island residents who lost their passport before international travel, study abroad, or federal TDY.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Rock Island and Quad Cities area families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Rock Island and Rock Island County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Rock Island residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Rock Island residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Rock Island business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rock Island IL", description: "Urgent passport processing for Rock Island Illinois travelers and Augustana College students with immediate departure needs." },
    { name: "Expedited Passport Renewal Rock Island IL", description: "Fast passport renewal for Rock Island Illinois residents and Quad Cities travelers." },
    { name: "First-Time Passport Rock Island IL", description: "New passport application services for Rock Island Illinois residents." },
    { name: "Child Passport Rock Island IL", description: "Minor passport services for Rock Island Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Erik L.",
      location: "Rock Island, IL — Augustana College",
      rating: 5,
      text: "Augustana's J-term study abroad to Sweden was confirmed and I had 9 days to get my first passport. Fast Passport Center walked me through the whole DS-11 process and I had it in 4 days. The Rock Island post office was easy. Now I'm in Stockholm for the semester. Every Augie student needs to know about this.",
      service: "First-Time Passport",
    },
    {
      name: "Col. (Ret.) James R.",
      location: "Rock Island, IL — Arsenal Island",
      rating: 5,
      text: "Federal civilian TDY to Japan and my passport expired during COVID. Had 7 days to get it together. Fast Passport Center renewed it in 3 days. Shipped from the UPS on 11th Street. Made it to Tokyo on time. Arsenal Island personnel — this is the service you need.",
      service: "Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Rock Island, IL",
      rating: 5,
      text: "Family reunion in Mexico — booked the trip then realized all 3 kids' passports were expired. Fast Passport Center got all 3 child passports done in 5 days. The Rock Island County Circuit Clerk was incredibly helpful. Quad Cities families, don't stress — these folks have you covered.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "rki-1",
      name: "Rock Island Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2633 11th St",
      city: "Rock Island",
      state: "IL",
      zip: "61201",
      phone: "(309) 788-9188",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Rock Island, near Augustana College and downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Rock Island acceptance facility. Extended hours until 5 PM — one of the latest-closing facilities in the Quad Cities. Convenient to Augustana College and downtown Rock Island. Near the Mississippi River and Centennial Bridge. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "rki-2",
      name: "Rock Island County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "13120 3rd St",
      city: "Rock Island",
      state: "IL",
      zip: "61201",
      phone: "(309) 558-3312",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Rock Island, Rock Island County Courthouse, downtown",
      website: "https://www.rockislandcounty.org/",
      websiteLabel: "Rock Island County Circuit Clerk",
      notes: "Rock Island County acceptance facility at the county seat. Historic courthouse in downtown Rock Island. Close to Arsenal Island and the government district. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "rki-3",
      name: "Moline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "514 17th St",
      city: "Moline",
      state: "IL",
      zip: "61265",
      phone: "(309) 764-7761",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Moline, approximately 2 miles east of Rock Island",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Rock Island residents near the Moline border. Near John Deere World HQ and the riverfront. Good alternative to Rock Island post office.",
      icon: "ri-mail-line",
    },
    {
      id: "rki-4",
      name: "Milan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "117 W 3rd St",
      city: "Milan",
      state: "IL",
      zip: "61264",
      phone: "(309) 787-2831",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Milan, approximately 5 miles south of Rock Island",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Milan and southern Rock Island County. Convenient for residents near the Rock River and south Rock Island. Smaller facility with generally shorter waits.",
      icon: "ri-mail-line",
    },
    {
      id: "rki-5",
      name: "East Moline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "805 16th Ave",
      city: "East Moline",
      state: "IL",
      zip: "61244",
      phone: "(309) 755-6002",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Moline, approximately 7 miles east of Rock Island",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves East Moline and eastern Rock Island County. Near John Deere Harvester Works and QC Airport area. Good option for eastern county residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.75 hour drive to Chicago", fpc: "No — ship from Rock Island" },
    { feature: "Time Commitment", agency: "5.5+ hour round trip — half day lost", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for QC", agency: "No — half a day for the drive", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Augustana J-Term Deadlines",
      description: "Augustana College students regularly discover expired or missing passports just weeks before J-term study abroad programs. With Chicago nearly 3 hours away, students have few in-person emergency options. Our courier service is the fastest practical solution for Augie students.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Chicago Drive",
      description: "Many Quad Cities residents think they can 'just drive to Chicago' for a passport emergency. At 2.75 hours each way plus downtown Chicago traffic and parking, this is a 5.5+ hour ordeal — half a workday that most people simply cannot spare.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many Augustana students and Quad Cities travelers don't know that numerous countries require 6 months of passport validity past the return date. A passport valid for 4 months is effectively expired for most European destinations popular with Augie study abroad programs.",
    },
    {
      icon: "ri-image-line",
      title: "Student ID vs. Passport Photos",
      description: "Augustana College student IDs do not meet Department of State passport photo standards. The lighting, background, and sizing requirements are completely different. Always use a dedicated passport photo service.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Rock Island and Moline acceptance facilities. Our document review catches this before submission — especially important for first-time student applicants.",
    },
    {
      icon: "ri-global-line",
      title: "Study Abroad Visa Confusion",
      description: "Augustana study abroad students often confuse passport validity requirements with visa requirements. Your passport must be valid for the entire stay plus the 6-month buffer. Visa processing is separate — start both processes early because neither can be rushed at the last minute.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Rock Island or Rock Island County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on 11th Street or near the District." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with Augustana study abroad, Arsenal Island federal travel, and QC family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — under 3 hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rock Island address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Rock Island, IL?", a: "Fast Passport Center offers emergency passport processing in Rock Island, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (2 hours 45 minutes east via I-88) — without you making the trip. For Quad Cities residents, this saves a half-day of driving and Chicago navigation." },
    { q: "Does Rock Island have a passport agency?", a: "No — Rock Island does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 2 hours 45 minutes east via I-88 and I-290. Fast Passport Center's courier service is the most practical fast option for the Quad Cities — especially for Augustana College students who need their passports for study abroad." },
    { q: "Do you serve Augustana College students?", a: "Absolutely. Fast Passport Center serves Augustana College students, faculty, and staff. We understand J-term deadlines, semester abroad programs, and international academic travel. Our 24–48 hour service is ideal for students who applied late or received last-minute acceptance to study abroad programs." },
    { q: "What airport do Rock Island travelers use for international flights?", a: "Quad Cities International Airport (MLI) in nearby Moline offers regional connecting flights. For most international flights, Quad Cities travelers use Chicago O'Hare (ORD) — approximately 2.5 hours east via I-88. Some also use Des Moines International (DSM) — approximately 2.5 hours west on I-80." },
    { q: "Can Arsenal Island personnel use your passport services?", a: "Yes. Fast Passport Center serves federal civilian employees, contractors, and personnel at the Rock Island Arsenal. We understand government travel (TDY) timelines and can help with both official and personal passport needs. Note: official government passports follow a different process — contact us for details." },
    { q: "Can I get my child's passport expedited in Rock Island?", a: "Yes. Fast Passport Center expedites child passports in Rock Island for minors under 16. Both parents must appear or submit notarized consent. We guide Quad Cities families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Rock Island?", a: "Walgreens on 11th Street, CVS on 18th Avenue, and the UPS Store in Rock Island all offer passport photos. The Rock Island Post Office on 11th Street also provides photo services. Augustana College's campus services may offer photos for students during the academic year. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in the Quad Cities?", a: "Honestly — no. The Chicago Passport Agency is nearly 3 hours away and requires appointments booked weeks in advance for non-emergencies. For urgent international travel from the Quad Cities, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why Augustana College students, Arsenal Island personnel, and Quad Cities families rely on us." },
  ],
  photoLocations: [
    { name: "Walgreens — Rock Island", address: "3100 11th St, Rock Island, IL 61201", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Rock Island", address: "3824 46th Ave, Rock Island, IL 61201", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Rock Island", address: "3930 18th Ave, Rock Island, IL 61201", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Rock Island Post Office", address: "2633 11th St, Rock Island, IL 61201", hours: "Mon–Fri: 9AM–5PM (photo services by appointment)" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Rock Island", address: "400 24th St, Rock Island, IL 61201", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located near Augustana College and the Rock Island County Courthouse. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Moline", address: "2001 52nd Ave, Moline, IL 61265", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Moline and eastern Rock Island County. REAL ID processing available. Near SouthPark Mall — good alternative with generally shorter wait times.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Rock Island County birth and death certificates" },
    { label: "Marriage Licenses (Rock Island County Clerk)", url: "https://www.rockislandcountyil.gov/178/County-Clerk", desc: "Rock Island County Clerk — marriage license applications and certified copies for Rock Island and Quad Cities" },
    { label: "Divorce Decrees (Rock Island County Circuit Clerk)", url: "https://www.rockislandcountyil.gov/174/Circuit-Clerk", desc: "Rock Island County Circuit Clerk — divorce decree records for Rock Island and Rock Island County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "Approximately 10 minutes east of Rock Island via I-74/IL-5",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Regional airport serving the Quad Cities with daily flights to Chicago O'Hare, Dallas, Atlanta, and other major hubs. Convenient for domestic connections and regional travel. About 10 minutes from downtown Rock Island.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 2 hours 45 minutes east via I-88",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Quad Cities international travelers and Augustana study abroad students use ORD for direct international flights. About 2.75 hours from Rock Island.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "Approximately 2 hours 30 minutes west via I-80",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Alternative airport for Quad Cities travelers. Good for Southwest Airlines connections and some international routes. About 2.5 hours from Rock Island via I-80 west.",
      flightUrl: "https://www.flydsm.com/",
      flightLabel: "DSM Flight Info",
      featured: false,
    },
  ],
};